import {documentToHtmlString} from '@contentful/rich-text-html-renderer'
import {resolveGenericContentCta, type GenericContent} from '../../../../../../brand/lib/types/contentful'

import {Heading, Prose} from '@primer/react-brand/esm'
import {CtaButtons} from '../../_shared/CtaButtons/CtaButtons'
import {Label} from '../../_shared/Label/Label'
import {Spacer} from '../../_shared/Spacer/Spacer'
import {MediaAsset} from '../../_shared/MediaAsset/MediaAsset'
import {Product} from '../../_shared/Product/Product'

import Styles from './River.module.css'

type Props = {
  content: GenericContent
  location: string
  sectionId: string
  sectionIndex: number
}

export function River(props: Props) {
  const {content, location, sectionId, sectionIndex} = props
  const {htmlId, heading, subheading, label, text, media} = content.fields
  const productPlacement = media?.at(0)?.fields.id

  const direction = htmlId || 'left' // Used for setting left/right alignment

  const title = heading

  const eyebrow = label?.fields.text
  const description = text ? documentToHtmlString(text) : ''

  const ctaGroup = resolveGenericContentCta(content, {legacyFallback: 'first'})
  const ctaNote = subheading ? documentToHtmlString(subheading) : ''

  return (
    <div className={Styles.River} data-direction={direction}>
      <div className={Styles.Cell}>
        <div className={Styles.Wrapper}>
          {eyebrow && <Label text={eyebrow} />}

          <div className={Styles.Content}>
            {title && (
              <Heading data-heading="2" as={sectionIndex === 0 ? 'h2' : 'h3'}>
                {title}
              </Heading>
            )}

            {description && (
              <>
                <Spacer size="8px" />
                <Prose className={Styles.Description} html={description} />
              </>
            )}

            {ctaGroup && (
              <>
                <Spacer size="64px" size1280="0" />
                <div>
                  <CtaButtons contentfulContent={ctaGroup} location={location} />
                  {ctaNote && <Prose className={Styles.CtaNote} html={ctaNote} />}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className={Styles.Cell}>
        {media && (
          <Product placement={productPlacement} sectionId={sectionId} variant="river">
            <div>
              <div>
                <MediaAsset content={media} location={location} />
              </div>
            </div>
          </Product>
        )}
      </div>
    </div>
  )
}
